import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import EventList from './EventList';

const queryClient = new QueryClient();
const Event = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <EventList />
    </QueryClientProvider>
  );
};

export default Event;
